$(document).ready(function () {
    $('.profile-images-wrapper').lightGallery({
        selector: '.light-link'
    });


    function initLattice(gallery) {
        if (!gallery || gallery.__latticeInit) return;
        gallery.__latticeInit = true;

        const num = (v) => {
            const n = parseFloat(v);
            return Number.isFinite(n) ? n : 0;
        };

        const recalc = () => {
            const styles = getComputedStyle(gallery);
            const rowSize = num(styles.getPropertyValue('grid-auto-rows'));
            const gap = num(styles.getPropertyValue('gap'));
            if (!rowSize) return;

            gallery.querySelectorAll('.gallery-card').forEach((card) => {
                const img = card.querySelector('img');
                if (!img) return;

                const h = img.getBoundingClientRect().height;
                if (!h) return;

                const span = Math.ceil((h + gap) / (rowSize + gap));
                card.style.gridRowEnd = `span ${Math.max(span, 1)}`;
            });
        };

        const schedule = () => requestAnimationFrame(recalc);
        gallery.__latticeRecalc = schedule;

        gallery.querySelectorAll('img').forEach((img) => {
            if (img.complete) return;
            img.addEventListener('load', schedule, { once: true });
            img.addEventListener('error', schedule, { once: true });
        });

        if (window.ResizeObserver) {
            const ro = new ResizeObserver(() => schedule());
            ro.observe(gallery);
        } else {
            let t;
            window.addEventListener('resize', () => {
                clearTimeout(t);
                t = setTimeout(schedule, 80);
            });
        }

        schedule();
    }

    document.querySelectorAll('.gallery').forEach((g) => {
        if (g.offsetParent !== null) initLattice(g);
    });

    $(document).on('shown.bs.modal', '.fsModal', function () {
        this.querySelectorAll('.gallery').forEach((g) => {
            initLattice(g);
            if (g.__latticeRecalc) {
                g.__latticeRecalc();
                setTimeout(g.__latticeRecalc, 50);
            }
        });
    });
});
